import NavigationLink from './NavigationLink';

export default NavigationLink;
